import React from 'react'
import PropTypes from 'prop-types'

import './RibbonComponent.scss'

const RibbonComponent = (props) => {
  const { iconNode, message, color, backgroundColor, className, styles } = props
  const wrapperStyles = {
    background: backgroundColor,
    color,
    ...styles,
  }

  return (
    <div
      className={`ribbon-component ${className || ''}`}
      style={wrapperStyles}
    >
      <span className="left-border" style={{ background: color }} />
      {iconNode}
      <div className="ribbon-content">{message}</div>
    </div>
  )
}

RibbonComponent.propTypes = {
  className: PropTypes.string,
  iconNode: PropTypes.node,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  styles: PropTypes.object,
}

RibbonComponent.defaultProps = {
  iconNode: null,
  backgroundColor: 'rgba(30,201,91, .04)',
  color: '#1ec95b',
  styles: {},
}

export default RibbonComponent
